import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../css/components/Navbar.css";
import logo from "../assets/Logo/Logo2.jpg";
import { useAuth } from "../context/authContext";
import { doSignOut } from "../firebase/auth";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userLoggedIn } = useAuth();
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Handle scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  const handleLogout = async () => {
    await doSignOut();
    navigate("/login");
  };

  // Close mobile menu when clicking a link
  const handleMobileNavClick = () => {
    setDropdownVisible(false);
  };

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/">
            <img src={logo} alt="CollegeNav Logo" />
          </Link>
        </div>

        <div className="navbar-links">
          <div className="nav-item">
            <Link to="/" className="nav-link">
              Home
            </Link>
          </div>

          <div className="nav-item dropdown">
            <Link to="/college" className="nav-link">
              College
            </Link>
            <div className="dropdown-content">
              <div className="dropdown-category">
                <Link to="/college-prep" className="category-header">
                  College Prep
                </Link>
                <Link to="/college-prep/highschool-roadmap">
                  High School Roadmap
                </Link>
                <Link to="/college-prep/different-paths">
                  Exploring Different Paths
                </Link>
                <Link to="/college-prep/majors">Choosing a Major</Link>
                <Link to="/college-prep/college-search-guide">
                  College Search
                </Link>
                <Link to="/college-prep/application-process">
                  Application Process
                </Link>
                <Link to="/college-prep/college-essay">College Essays</Link>
                <Link to="/college-prep/international-students">
                  International Students
                </Link>
              </div>

              <div className="dropdown-category">
                <Link to="/afford-college" className="category-header">
                  Afford College
                </Link>
                <Link to="/afford-college/financial-aid">Financial Aid</Link>
                <Link to="/afford-college/scholarship">Scholarships</Link>
                <Link to="/afford-college/student-work-opportunities">
                  Work Opportunities
                </Link>
              </div>

              <div className="dropdown-category">
                <Link to="/college-life" className="category-header">
                  College Life
                </Link>
                <Link to="/college-life/before-college">
                  Preparing for College
                </Link>
                <Link to="/college-life/college-tips">Essential Tips</Link>
                <Link to="/college-life/school-benefits">School Benefits</Link>
                <Link to="/college-life/stem-internships">Internships</Link>
                <Link to="/college-life/resume">Resume Building</Link>
              </div>
              <div className="dropdown-category">
                <Link to="/programs" className="category-header">
                  Programs
                </Link>
                <Link to="/programs/research-opportunities">
                  Research Opportunities
                </Link>
                <Link to="/programs/study-abroad">Study Abroad</Link>
                <Link to="/programs/mentorship-programs">Mentorship</Link>
                <Link to="/programs/tech-conferences">Tech Conferences</Link>
              </div>
            </div>
          </div>

          <div className="nav-item dropdown">
            <Link to="/tools" className="nav-link">
              Tools
            </Link>
            <div className="dropdown-content">
              <div className="dropdown-category">
                <Link to="/tools" className="category-header">
                  Tools
                </Link>
                <Link to="/tools/ai">college assistant</Link>
                {/* Hidden for now */}
                <Link to="/tools/early-career-search">Career Search</Link>
                {/* <Link to="/tools/financial-tracker">Financial Tracker</Link> */}
                {/* <Link to="/tools/gpa-calculator">GPA Calculator</Link> */}
                <Link to="/tools/college-search">College Search</Link>
                <Link to="/tools/scholarship-search">Scholarship Search</Link>
                <Link to="/tools/virtual-tour">Virtual Tours</Link>
              </div>
            </div>
          </div>

          <div className="nav-item">
            <Link to="/about-us" className="nav-link">
              About Us
            </Link>
          </div>

          {userLoggedIn && (
            <div className="nav-item">
              <Link to="/profile" className="nav-link">
                Profile
              </Link>
            </div>
          )}
        </div>

        <div className="navbar-auth">
          {userLoggedIn ? (
            <button onClick={handleLogout} className="auth-button logout-btn">
              Log Out
            </button>
          ) : (
            <Link to="/login" className="auth-button login-btn">
              Log In
            </Link>
          )}
        </div>

        <div className="navbar-mobile-toggle">
          <button
            className={`menu-toggle ${isDropdownVisible ? "active" : ""}`}
            onClick={toggleDropdown}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      <div className={`mobile-menu ${isDropdownVisible ? "open" : ""}`}>
        <div className="mobile-menu-container">
          <Link to="/" className="mobile-link" onClick={handleMobileNavClick}>
            Home
          </Link>
          <Link
            to="/college"
            className="mobile-link"
            onClick={handleMobileNavClick}
          >
            College
          </Link>
          <Link
            to="/tools"
            className="mobile-link"
            onClick={handleMobileNavClick}
          >
            Tools
          </Link>
          <Link
            to="/about-us"
            className="mobile-link"
            onClick={handleMobileNavClick}
          >
            About Us
          </Link>

          {userLoggedIn && (
            <Link
              to="/profile"
              className="mobile-link"
              onClick={handleMobileNavClick}
            >
              Profile
            </Link>
          )}

          {userLoggedIn ? (
            <button
              onClick={handleLogout}
              className="mobile-auth-button logout-btn"
            >
              Log Out
            </button>
          ) : (
            <Link
              to="/login"
              className="mobile-auth-button login-btn"
              onClick={handleMobileNavClick}
            >
              Log In
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
